const PREFIX = '';
const DECIMAL_SEPARATOR = '.';
const THOUSANDS_SEPARATOR = ',';
const BLANK = '';
const SUFFIX = '$';
const PADDING = '000000';

export const transformCurrency = (value, fractionSize, showSuffix = true) => {
  let [integer, fraction = ''] = (value || '').toString().split('.');

  fraction = fractionSize > 0 ? DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize) : '';

  integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, THOUSANDS_SEPARATOR);

  if (!showSuffix) return PREFIX + integer + fraction;

  return SUFFIX + PREFIX + integer + fraction;
};
